import Vue from 'vue'

import MetricSelector from './metric/MetricSelector'
import PrefferedMetricSelector from './metric/PrefferedMetricSelector'
import MetricSelector2 from './metric/MetricSelector2'
import SimpleQuantityWidget from './metric/SimpleQuantityWidget'

import SelectInventoryDefinition from '@/components/select/SelectInventoryDefinition'
import SelectPriceList from '@/components/select/SelectPriceList'
import SelectCurrency from '@/components/select/CurrencySelect'
import SelectInventoryTXCategory from '@/components/select/SelectInventoryTXCategory'
import SelectInventoryDefinitionDialog from '@/components/dialogs/select-inv-def/Dialog'
import BuildSelect from '@/components/select/SelectProductBuild'
import SelectCustomer from '@/components/select/SelectCustomer'
import PriceSelect from '@/components/select/PriceSelect'
import SelectSupplier from '@/components/select/SelectSupplier'

import CostPerUnit from '@/components/select/CostPerUnit'
import DatePicker from '@/components/select/SelectDate'
import SelectDateTime from '@/components/select/SelectDateTime'
import SaveButton from './ui/SaveButton'
import Table from './table/Table'
import RealTable from './table/RealTable'
import SimpleTable from './table/SimpleTable'
import CList from './list/C-List'
import CListSort from './list/ListSortMenu'
import DebitTable from './table/debit-table/DebitTable'
import CDialog from './ui/C-Dialog'
import CInput from './ui/C-Input'
import CTextarea from './ui/C-TextArea'
import CBreadcrumbs from './ui/C-breadcrumb'
import PeekDefinition from '@/components/peek/inventory-def-name'

// TABLE LIST SERVER
import CTableHeader from '@/components/list-server/th'
import CPagination from '@/components/list-server/pagination'

// TABLE LIST CLIENT
import PaginationClientList from '@/components/list/pagination'


// Transitions
import CTransitionExpand from './transitions/expand'
import CTransitionToolbarUp from './transitions/toolbar-up'
// TOOLBOX
import ItemDiff from './toolbox/item-diff/ItemDiff'
import JsonViewer from "@/components/toolbox/json-viewer/Main";
import JsonInspector from "@/components/toolbox/item-inspector/main";

// UI COMPONENTS
import CExpansionPanel from './ui/expansion-panel/C-ExpansionPanel'
// LIST
import CListItemsPerPage from '@/components/list/C-ListItemsPerPage' // deprecate THIS
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'

Vue.component('c-metric-selector', MetricSelector)
Vue.component('c-preffered-metric-selector', PrefferedMetricSelector)
Vue.component('c-ms-ii', MetricSelector2)
Vue.component('c-quantity', SimpleQuantityWidget)
Vue.component('c-price', PriceSelect)

Vue.component('c-select-build', BuildSelect)
Vue.component('c-select-price-list', SelectPriceList)
Vue.component('c-select-currency', SelectCurrency)
Vue.component('c-select-inv-def', SelectInventoryDefinition)
Vue.component('c-select-inv-def-dialog', SelectInventoryDefinitionDialog)
Vue.component('c-select-inv-tx-category', SelectInventoryTXCategory)
Vue.component('c-select-customer', SelectCustomer)
Vue.component('c-select-supplier', SelectSupplier)

Vue.component('c-cost-per-unit', CostPerUnit)
Vue.component('c-date', DatePicker)
Vue.component('c-datetime', SelectDateTime)
Vue.component('c-save-btn', SaveButton)
Vue.component('c-table', Table)
Vue.component('c-real-table', RealTable)
Vue.component('c-simple-table', SimpleTable)

Vue.component('c-list', CList)
Vue.component('c-list-sort', CListSort)

Vue.component('c-debit-table', DebitTable)
Vue.component('c-dialog', CDialog)
Vue.component('c-input', CInput)
Vue.component('c-textarea', CTextarea)
Vue.component('c-breadcrumbs', CBreadcrumbs)
Vue.component('c-peek-definition', PeekDefinition)

// Table server
Vue.component('c-table-header', CTableHeader)
Vue.component('c-pagination', CPagination)

// Table client
Vue.component('c-pagination-client', PaginationClientList)



// Transitions
Vue.component('c-transition-expand', CTransitionExpand)
Vue.component('c-transition-toolbarup', CTransitionToolbarUp)
// TOOLBOX
Vue.component('t-item-diff', ItemDiff)
Vue.component('json-viewer', JsonViewer)
Vue.component('json-inspector', JsonInspector)
// UI COMPONENTS
Vue.component('c-expansion-panel', CExpansionPanel)
// LIST
Vue.component('c-list-items-per-page', CListItemsPerPage)
Vue.component('c-s-list-items-per-page', CSListItemsPerPage)
